var _path, _path2, _path3, _path4, _path5, _path6, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 73C56.8823 73 73 56.8823 73 37C73 17.1177 56.8823 1 37 1C17.1177 1 1 17.1177 1 37C1 56.8823 17.1177 73 37 73Z",
    fill: "#222222",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 0.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4483 23C35.8389 23 35.3448 23.494 35.3448 24.1034C35.3448 24.7129 35.8389 25.2069 36.4483 25.2069H51.8966C52.506 25.2069 53 24.7129 53 24.1034C53 23.494 52.506 23 51.8966 23H36.4483Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4483 29.6207C35.8389 29.6207 35.3448 30.1148 35.3448 30.7242C35.3448 31.3336 35.8389 31.8276 36.4483 31.8276H51.8966C52.506 31.8276 53 31.3336 53 30.7242C53 30.1148 52.506 29.6207 51.8966 29.6207H36.4483Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1034 36.2413C21.494 36.2413 21 36.7354 21 37.3448C21 37.9542 21.494 38.4482 22.1034 38.4482H51.8966C52.506 38.4482 53 37.9542 53 37.3448C53 36.7354 52.506 36.2413 51.8966 36.2413H22.1034Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1034 42.8621C21.494 42.8621 21 43.3561 21 43.9655C21 44.5749 21.494 45.069 22.1034 45.069H51.8966C52.506 45.069 53 44.5749 53 43.9655C53 43.3561 52.506 42.8621 51.8966 42.8621H22.1034Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1034 49.4828C21.494 49.4828 21 49.9768 21 50.5862C21 51.1957 21.494 51.6897 22.1034 51.6897H51.8966C52.506 51.6897 53 51.1957 53 50.5862C53 49.9768 52.506 49.4828 51.8966 49.4828H22.1034Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 11.0345,
    height: 8.82759,
    rx: 2.2069,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/article_icon.8032fe719e0f3509507bbdee5e04f117.svg";
export { ForwardRef as ReactComponent };